import { Document } from '../../../types'
import { getDocumentUrl } from '../../../utils/helpers'
import './DocumentCard.css'

interface DocumentCardProps {
  document: Document
}

function DocumentCard({ document }: DocumentCardProps) {
  const getFileExtension = (url: string): string => {
    const match = url.match(/\.([^.]+)$/)
    return match ? match[1].toLowerCase() : 'file'
  }

  const getFileIcon = (url: string): string => {
    const ext = getFileExtension(url)
    const icons: { [key: string]: string } = {
      pdf: '📄',
      doc: '📝',
      docx: '📝',
      txt: '📄',
      jpg: '🖼️',
      jpeg: '🖼️',
      png: '🖼️',
      gif: '🖼️',
      zip: '📦',
      rar: '📦'
    }
    return icons[ext] || '📁'
  }

  const getFileType = (url: string): string => {
    const ext = getFileExtension(url)
    const types: { [key: string]: string } = {
      pdf: 'PDF',
      doc: 'DOC',
      docx: 'DOCX',
      txt: 'TXT',
      jpg: 'JPG',
      jpeg: 'JPEG',
      png: 'PNG',
      gif: 'GIF',
      zip: 'ZIP',
      rar: 'RAR'
    }
    return types[ext] || ext.toUpperCase()
  }

  const getCategoryLabel = (category: string): string => {
    const labels: { [key: string]: string } = {
      flyers: 'Tract',
      programme: 'Programme',
      communiques: 'Communiqué',
      autres: 'Autre'
    }
    return labels[category] || category
  }

  const rawUrl = document.download_url || document.media?.file_path || ''
  const fileUrl = rawUrl ? getDocumentUrl(rawUrl) : ''

  return (
    <div className="document-card">
      <div className="document-card-header">
        <div className="document-icon">
          {fileUrl && getFileIcon(fileUrl)}
        </div>
        <div className="document-meta">
          <span className="document-category">{getCategoryLabel(document.category)}</span>
          <span className="document-type">{fileUrl ? getFileType(fileUrl) : 'N/A'}</span>
        </div>
      </div>

      <div className="document-card-body">
        <h3 className="document-title">{document.title}</h3>
        <p className="document-description">{document.description}</p>
      </div>

      <div className="document-card-footer">
        {fileUrl ? (
          <a
            href={fileUrl}
            className="btn-download"
            target="_blank"
            rel="noopener noreferrer"
            download
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 11L4 7L5.4 5.55L7 7.15V1H9V7.15L10.6 5.55L12 7L8 11ZM3 15C2.45 15 1.979 14.804 1.587 14.412C1.195 14.02 0.999333 13.5493 1 13V10H3V13H13V10H15V13C15 13.55 14.804 14.021 14.412 14.413C14.02 14.805 13.5493 15.0007 13 15H3Z"
                fill="currentColor"
              />
            </svg>
            Télécharger
          </a>
        ) : (
          <span className="btn-download disabled">Fichier non disponible</span>
        )}
      </div>
    </div>
  )
}

export default DocumentCard
